import React from 'react';
import classNames from 'classnames';
import RowGridCalendar from './RowGridCalendar';

const Calendar = ({ units = [], reservations = {}, onClickReservation, scrollLeft, calendarDates, datesRangeSelected = [] }) => {
  const handleClickBlock = (blockInfo) => {
    if (blockInfo.type === 'reservation') onClickReservation(blockInfo.booked_for);
  };
  const formatBlockInfo = (info) => {
    if (info.available) return '';
    if (info.notInitialized) return '';
    if (info.type === 'blocked_date') return info.blocked_by;
    if (info.type === 'reservation') {
      const reservationInfo = reservations.find(r => r.reference === info.booked_for) || {};
      return (
        <div>
          { reservationInfo.reference || ''} - { reservationInfo.origin || '' }<br/>
          { (reservationInfo.customer || {}).name }
        </div>
      );
    }
    return '';
  };
  const getClassName = (info) => {
    if (info.available) return 'available';
    if (info.notInitialized) return 'not-initialized';
    if (info.type === 'blocked_date') return 'blocked-date';
    if (info.type === 'reservation') return 'reservation';
  };
  const selectedDates = datesRangeSelected.slice().sort((a, b) => a.localeCompare(b));
  return (
    <div>
      <div className="left-column" style={ { left: scrollLeft } }>
        <table>
          <tbody>
            {
              units.map((unit, i) => {
                return (
                  <tr className="row-prices" key={ i }>
                    <td>{ unit.label }</td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
      <div className="grid">
        <table>
          <tbody>
            { /* Display one row by unit to make a transparent grid */
              units.map((unit, i) => {
                return (
                  <RowGridCalendar
                    key={ i }
                    calendarDates={ calendarDates }
                    selectedDates={ selectedDates } />
                );
              })
            }
          </tbody>
        </table>
      </div>
      <div className="booked-dates">
        <table>
          <tbody>
            <tr className="dummy">
            { /* Used as reference for colspan */
              calendarDates.map((calDate, i) => {
                return (<td key={ i }></td>);
              })
            }
            </tr>
            {
              units.map((unit, i) => {
                return (
                  <tr className="row-bookings" key={ i }>
                    {
                      unit.dates.map((date, j) => {
                        return (
                          <td key={ j } colSpan={ date.nb_days } className={ getClassName(date) } onClick={ handleClickBlock.bind(null, date) }>
                            { formatBlockInfo(date) }
                          </td>
                        );
                      })
                    }
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/components/Calendar.jsx